<!--
<section class="auth-layout">
  <div class="container">

      <p-tabView (onChange)="onTabChange($event)">
        <p-tabPanel header="Freelancer"></p-tabPanel>
        <p-tabPanel header="User"></p-tabPanel>
      </p-tabView>


    <div class="card mb-5">
        <div class="row">
            <div class="align-self-baseline" [ngClass]="{'col-md-7 col-12': !(( currentPath ==  'user-signup') && (isMobile) && (type =='freelance')) , 'col-lg-12 col-12': (( currentPath ==  'user-signup') && (isMobile) && (type =='freelance'))}">
                <div class="auth-pages py-2" [@zoomIn]="type">
                  <router-outlet></router-outlet>
                </div>
            </div>
            <div class=" " [ngClass]="{'col-md-5 col-12': !(( currentPath ==  'user-signup') && (isMobile) && (type =='freelance')) , 'd-none': (( currentPath ==  'user-signup') && (isMobile) && (type =='freelance'))}">
               <div class="image-background" [ngClass]="{'login': currentPath != 'user-signup' , 'signup': currentPath != 'login'}" ></div>
            </div>
        </div>
    </div>
  </div>
</section>
 -->
<section class="auth-layout">
  <div class="navbar">
    <div class="container d-flex justify-content-between align-items-center py-3">
      <a (click)="navigateToHome()" class="brand-logo">
        <img src="assets/images/logo.svg" alt="Logo" height="50px" />
      </a>

      <button class="btn" (click)="navigateToHome()">
        <h6>Back to home</h6>
      </button>
    </div>
  </div>
  <section class="auth-pages" [@zoomIn]="">
    <div class="container h-100">
      @if (checkType) {
        <div class="row mt-4 h-100">
          <div class="col-xl-7 col-lg-6 col-12 align-self-center">
            <router-outlet></router-outlet>
          </div>
          <div
            class="col-xl-5 col-lg-6 align-items-center image-background"
            [ngStyle]="{ backgroundImage: 'url(' + images[type] + ')' }"
          ></div>
        </div>
      } @else {
        <app-detect-type></app-detect-type>
      }
    </div>
  </section>
</section>
